import { render, staticRenderFns } from "./eventos.vue?vue&type=template&id=20eca66e"
import script from "./eventos.vue?vue&type=script&lang=js"
export * from "./eventos.vue?vue&type=script&lang=js"
import style0 from "./eventos.vue?vue&type=style&index=0&id=20eca66e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports